import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { Parser as HtmlToReactParser } from 'html-to-react';
import { useIntl } from 'react-intl';
import { PageContext } from './context/AppContext';


/*
* Wrapper translation function (just to remove defaultMessage warning)
*/
export function formatMessage(intl, id, defaultMessage, options) {
    if (intl.locale === intl.defaultLocale || !(id in intl.messages)) {
        return defaultMessage;
    }
    return intl.formatMessage({ id }, options);
}

const htmlToReactParser = new HtmlToReactParser();

/*
* Function translate for seo
*/
export function translate(id, intl, children) {
    let content = null;

    if (intl.locale === intl.defaultLocale || !(id in intl.messages)) {
        content = children;
    } else {
        const message = formatMessage(intl, id, null, undefined);
        if (typeof message === 'string') {
            content = htmlToReactParser.parse(message);
        } else {
            content = message;
        }
    }
    return content;
}

/*
* Wrapper component around translation function
*/
export default function Translation(props) {
    const {
        id,
        tag,
        children,
        className,
        ...otherProps
    } = props;

    const intl = useIntl();
    const { pageContext: { localePagesId } } = useContext(PageContext);
    const messageId = id.includes('.') ? id : `${localePagesId}.${id}`;

    let content = null;
    const ContainerTag = tag;
    if (intl.locale === intl.defaultLocale || !(messageId in intl.messages)) {
        content = children;
    } else {
        const valuesObj = Object.keys(otherProps).length ? otherProps : undefined;
        const message = intl.formatMessage({ id: messageId }, valuesObj);
        if (typeof message === 'string') {
            content = htmlToReactParser.parse(message);
        } else {
            content = message;
        }
    }

    return (ContainerTag
        ? <ContainerTag className={className}>{content}</ContainerTag>
        : content
    );
}

Translation.defaultProps = {
    children: undefined,
    className: undefined,
    tag: undefined,
};

Translation.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    id: PropTypes.string.isRequired,
    tag: PropTypes.string,
};
